import { Icon, SvgSpinner } from '@tmapy/style-guide';

import type { DataComponent } from '../../types';

import { useUploadFile } from './useUploadFile';

export const FileInput: DataComponent = ({ onChange, loading }) => {
  const { handleChange, isUploading } = useUploadFile({ onChange });

  return (
    <div className='sg-a-d-f sg-a-ai-c sg-a-cg-1'>
      <input type='file' onChange={handleChange} disabled={loading} />
      {isUploading && (
        <span className='sg-a-f-n'>
          <Icon element={<SvgSpinner />} />
        </span>
      )}
    </div>
  );
};
